import React, { Component } from 'react'
import {
    MDBContainer,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter
} from 'mdbreact';
import { MDBRow, MDBCol, MDBIcon } from "mdbreact";
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip , Divider } from 'antd';
import { api } from '../../api';
import Swal from 'sweetalert2'


export default class Modaladdcarparts extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            loading: false,
            namework: '',
            fileupload: '',

            carparts_code:'',
            carparts_name:'',
            carparts_price:'',

            name_workorder: '',
            worklistdata: [],
           
            filedesing_workorder: '',
            value: 1,

        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggle = this.toggle.bind(this);
      //  this.handleChangefile = this.handleChangefile.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
       
    }
    onTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    //handleChangefile(event) {    this.setState({fileupload: event.target.files[0]});  }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        // alert('A name was submitted: ' + this.state.value);
        const date = new Date().toISOString().slice(0, 10)
       setTimeout(() => {
    
          const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
          datafrm.append("carparts_code", this.state.carparts_code);
          datafrm.append("carparts_name", this.state.carparts_name);
          datafrm.append("carparts_price", this.state.carparts_price);
          //datafrm.append("id_workorder", this.state.id_workorder);
        
          api.post("insertcarparts.php",datafrm,{
                headers: {
                    'content-type': 'multipart/form-data'
                }
            })
    
       .then(res => {
        if (res.status=== 200) {
            Swal.fire({
                title: 'บันทึกข้อมูลสำเร็จ',
                icon: 'success',
              // showCancelButton: true,
                confirmButtonText: 'ตกลง',
              // cancelButtonText: 'No, keep it'
              }).then((result) => {
                this.toggle();  
            //  this.getworklist();
                this.props.getcategory();
              })
        }else{
          message.error("บันทึกข้อมูลไม่สำเร็จ!")
        }
    
      })
    
    
    }, 2000);
    
    //window.location.href = '/adminfaculty'
    //this.props.updateat();
    //this.getExpert()
     
      }

    render() {
   // console.log(this.state.namework)
 //   console.log(this.state.fileupload)
        return (
            <MDBContainer>
                <MDBBtn color="pink" onClick={this.toggle}>เพิ่มอะไหล่</MDBBtn>
                <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                    <MDBModalHeader toggle={this.toggle}>เพิ่มอะไหล่</MDBModalHeader>
                    <MDBModalBody>

                        <form onSubmit={this.handleSubmit}>
                            <div className="mb-2 text-left">
                                <label className="font-weight-bold text-left"><MDBIcon icon="bible" /> รหัส</label>
                                <input className="form-control" onChange={this.onTextChange} name="carparts_code"
                                    value={this.state.carparts_code} placeholder="รหัส" required />
                            </div>
                            <div className="mb-2 text-left">
                                <label className="font-weight-bold text-left"><MDBIcon icon="bible" /> ชื่ออะไหล่</label>
                                <input className="form-control" onChange={this.onTextChange} name="carparts_name"
                                    value={this.state.carparts_name} placeholder="ชื่ออะไหล่" required />
                            </div>
                            <div className="mb-2 text-left">
                                <label className="font-weight-bold text-left"><MDBIcon icon="bible" /> ราคา</label>
                                <input className="form-control" onChange={this.onTextChange} name="carparts_price"
                                    value={this.state.carparts_price} placeholder="ราคา" required />
                            </div>
                           
                            {/* <p className="purple-text text-center">ตรวจสอบข้อมูลว่าถูกต้องครบถ้วน</p> */}
                            <div className="mt-3 text-center" >
                                <MDBBtn type="submit" color="deep-purple" className="text-center"> <MDBIcon far icon="save" /> เพิ่ม</MDBBtn>
                                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                            </div>

                        </form>
                    </MDBModalBody>
                    <MDBModalFooter>
                        {/* <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn> */}
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                    </MDBModalFooter>
                </MDBModal>
            </MDBContainer>
        )
    }
}
